import type {ReactElement} from 'react';
import {useState} from 'react';
import type {TimeZone} from 'timezones-list';
import {Dropdown} from '@Components/dropdown-v2';
import {MODALS_IDS} from '@Components/modal-container';
import {closeModal} from '@Components/modal-container/modal-container-reducer';
import {useAppDispatch} from '@/hooks';
import {ScreenBreakpoints} from '@Libraries/responsiveness-library';
import {DropdownGhostSelectBox} from '@Components/dropdown-v2/components/dropdown-ghost-select-box';
import {ALIGNMENT_TYPE, DROPDOWN_SIZE} from '@Components/dropdown-v2/dropdown.types';
import {getTimezoneDisplayLabel} from '@Components/event-wizard/timezone-content/timezone-content.helper';
import {CountdownTimezoneList} from '../countdown-timezone-list/countdown-timezone-list';
import type {CountdownTimezoneDropdownProps} from './countdown-timezone-dropdown.types';
import styles from './countdown-timezone-dropdown.module.scss';

export function CountdownTimezoneDropdown({selected, onSelect}: CountdownTimezoneDropdownProps): ReactElement {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const dispatch = useAppDispatch();

  function handleSelect(timezone: TimeZone): void {
    onSelect(timezone);
    setIsOpen(false);
    dispatch(closeModal(MODALS_IDS.MORE_OPTIONS_MODAL));
  }

  return (
    <Dropdown
      className={styles.selector}
      selector={<DropdownGhostSelectBox size={DROPDOWN_SIZE.XSMALL} text={getTimezoneDisplayLabel(selected, true)} />}
      popup={<CountdownTimezoneList className={styles.popup} selected={selected} onSelect={handleSelect} />}
      modalContent={<CountdownTimezoneList selected={selected} onSelect={handleSelect} />}
      alignment={ALIGNMENT_TYPE.BOTTOM_END}
      doCloseOnInnerClick={false}
      showModalForSmallScreen
      smallScreenWidthThresholdForModal={Number(ScreenBreakpoints.LARGE)}
      isSmallScreenModalBottomSheet
      modalTitle={window.i18next.t('pmwjs_time_zone')}
      popUpHasCustomWidth
      open={isOpen}
      onOpen={(): void => {
        setIsOpen(true);
      }}
      onClose={(): void => {
        setIsOpen(false);
      }}
    />
  );
}
